import { Accordion, AccordionProps } from "PFComponents/accordion";
import { Id } from "PFCore/types";

import { SkillsTable, SkillsTableProps } from "../../common/skills_table";
import css from "../skills_section.module.scss";
import { SkillsViewCommonProps } from "../skills_section.types";

type SkillsGroupAccordionProps = Pick<AccordionProps, "header" | "state" | "onStateChange"> &
  Omit<SkillsViewCommonProps, "searchTerm" | "setSearchTerm"> &
  Pick<SkillsTableProps, "skills" | "controlledSorting" | "onSortingChange" | "className"> & {
    profileId: Id;
  };

export const SkillsGroupAccordion = ({
  header,
  state,
  onStateChange,
  skills,
  profileId,
  ...props
}: SkillsGroupAccordionProps) => (
  <Accordion
    header={header}
    state={state}
    onStateChange={onStateChange}
    headerVariant="bodyBold"
    iconSet="chevron"
    animated={false} // needs to be false to make sticky table headers work
  >
    <SkillsTable
      {...props}
      skills={skills}
      profileId={profileId}
      className={css.tableNoAnchor}
      noInitialSorting
    />
  </Accordion>
);
